"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelize = void 0;
var camelize = function (source) { return source === null || source === void 0 ? void 0 : source.replace(/[_-]+(.)/g, function (_, p1) { return p1.toUpperCase(); }); };
exports.camelize = camelize;
//# sourceMappingURL=camelize.js.map